<template>
  <beautiful-chat
    :participants="participants"
    :onMessageWasSent="onMessageWasSent"
    :messageList="messageList"
    :newMessagesCount="newMessagesCount"
    :isOpen="isChatOpen"
    :close="closeChat"
    :open="openChat"
    :showHeader="true"
    :showEmoji="false"
    :showFile="false"
    :showEdition="true"
    :showDeletion="true"
    :showTypingIndicator="showTypingIndicator"
    :showLauncher="false"
    :showCloseButton="true"
    :colors="colors"
    :placeholder="$t('chatMessage.placeholder')"
    :alwaysScrollToBottom="alwaysScrollToBottom"
    :disableUserListToggle="true"
    :messageStyling="messageStyling"
    @onType="handleOnType"
    @edit="editMessage">
    <template v-slot:header>
      <img data-v-61edfd75="" src="https://web.luckcome.com/res/talk.png" alt=""
           class="sc-header--img">
      <div data-v-61edfd75="" class="sc-header--title">{{ $t('chatMessage.tips',{name: participants.length > 0 ? participants[0].name : ''}) }}
      <!-- 您正在和{{
          participants.length > 0 ? participants[0].name : ''
        }}沟通 -->
      </div>
    </template>
    <template v-slot:system-message-body="{ message }">
      <span class="sc-message-system-text">-- {{ message.text }} --</span>
    </template>
    <template v-slot:text-message-body="{ message }">
      <!--      <small style="background:red" v-if="message.meta">-->
      <!--        {{message.meta}}-->
      <!--      </small>-->
      {{ message.data.text }}
      <div class="chat-msg-loading" v-if="message.sendState===0"></div>
      <div class="chat-msg-retry" v-else-if="message.sendState===1" @click="retrySend(message)"></div>
    </template>
  </beautiful-chat>
</template>

<script>
import msgStorage from '../common/msg-storage'

export default {
  name: 'ChatMessage',
  data () {
    return {
      userAvatar: 'https://web.luckcome.com/res/head.png',
      participants: [],
      messageList: [],
      newMessagesCount: 0,
      isChatOpen: false,
      showTypingIndicator: '',
      colors: {
        header: {
          bg: '#52cdcd',
          text: '#ffffff'
        },
        launcher: {
          bg: '#ffffff'
        },
        messageList: {
          bg: '#ffffff'
        },
        sentMessage: {
          bg: '#67d1d1',
          text: '#ffffff'
        },
        receivedMessage: {
          bg: '#eaeaea',
          text: '#222222'
        },
        userInput: {
          bg: '#f4f7f9',
          text: '#565867'
        }
      },
      alwaysScrollToBottom: true,
      messageStyling: true
    }
  },
  created: function () {
  },
  mounted () {
  },
  methods: {
    // sendMessage (text) {
    //   if (text.length > 0) {
    //     this.newMessagesCount = this.isChatOpen ? this.newMessagesCount : this.newMessagesCount + 1
    //     this.onMessageWasSent({author: 'support', type: 'text', data: {text}})
    //   }
    // },
    onMessageWasSent (message) {
      // this.messageList = [...this.messageList, message]
      console.log('msg', 'add', message)

      const timestamp = new Date().getTime()
      msgStorage.save(this.participants[0].userId, this.participants[0].userType, 'me', timestamp, 0, message.data.text, true, false)
      this.$emit('onMessage', this.participants[0].userId, this.participants[0].userType, message.data.text, timestamp)
      if (this.participants.length === 0) return
      const newMsg = {
        type: 'text',
        author: 'me',
        data: {
          text: message.data.text
        },
        sendState: 0,
        hidden: 0,
        sendTime: timestamp,
        timer: 0
      }
      const timer = setTimeout(function () {
        newMsg.sendState = 1
      }, 3000)
      newMsg.timer = timer
      this.messageList.push(newMsg)
    },
    openChat (userId, userType, userName, messageInfo) {
      if (this.isChatOpen && this.participants.length !== 0 && this.participants[0].userId === userId && this.participants[0].userType === userType) {
        return
      }
      // called when the user clicks on the fab button to open the chat
      this.participants.splice(0, this.participants.length)
      this.participants.push({
        // 这里的id和聊天记录里的author对应
        id: userName,
        name: userName,
        imageUrl: this.userAvatar,
        userId: userId,
        userType: userType
      })
      this.participants.push({
        // 这里的id和聊天记录里的author对应
        id: 'me',
        name: '我',
        imageUrl: this.userAvatar,
        userId: 0
      })
      // {type: 'text', to: '', from: '', fromAuthor: '', data: {text: ''}, timestamp: 0, hidden: 0}
      // {type: 'text', author: '', data: {text: ''}, hidden: 0}
      let messageRecords = messageInfo.msg
      if ((messageRecords == null || messageRecords.length === 0) && messageInfo.seconds > 0) {
        this.loadHistoryMessage(userId, userType, messageInfo.seconds)
      } else {
        console.log('msg', 'format', messageRecords)
        this.loadMessage(messageRecords)
      }
      this.isChatOpen = true
      this.newMessagesCount = 0
    },
    formatMsg (list) {
      const data = []
      for (let i = 0; i < list.length; i++) {
        data.push({
          timestamp: list[i].createTime,
          hidden: 0,
          fromAuthor: list[i].author,
          data: {
            text: list[i].content
          },
          // 2 - 发送成功；1 - 发送失败；0 - loading中
          sendState: list[i].sendState ? 2 : 1
        })
      }
      return data
    },
    loadMessage (messageRecords) {
      this.messageList.splice(0, this.messageList.length)
      if (messageRecords) {
        for (let i = 0; i < messageRecords.length; i++) {
          const item = messageRecords[i]
          if (item.hidden === 0) {
            this.messageList.push({
              type: 'system',
              id: 0,
              data: {text: this.convert(item.timestamp)}
            })
            this.messageList.push({
              type: 'text',
              author: item.fromAuthor,
              data: {
                text: item.data.text
              },
              hidden: item.hidden,
              sendTime: item.timestamp,
              sendState: item.sendState
            })
          }
        }
      }
    },
    retrySend (message) {
      this.$emit('onMessage', this.participants[0].userId, this.participants[0].userType, message.data.text, message.sendTime)
      if (this.participants.length === 0) return
      message.sendState = 0
      if (message.timer) {
        clearTimeout(message.timer)
      }
      const timer = setTimeout(function () {
        message.sendState = 1
      }, 3000)
      message.timer = timer
    },
    closeChat () {
      this.isChatOpen = false
    },
    getOpenState () {
      return this.isChatOpen
    },
    handleScrollToTop () {
    },
    handleOnType () {
    },
    editMessage (message) {
      const m = this.messageList.find(m => m.id === message.id)
      m.isEdited = true
      m.data.text = message.data.text
    },
    refresh (args) {
      console.log('msg', args)
      const isSend = args.newMsg.fromAuthor === 'me'
      if (isSend) {
        msgStorage.updateSendState(args.userId, args.userType, args.timestamp, true)
        if (this.participants.length === 0) return
        if (args.newMsg && args.userId === this.participants[0].userId && args.userType === this.participants[0].userType) {
          console.log('msg', this.messageList)
          for (let i = 0; i < this.messageList.length; i++) {
            if (this.messageList[i].sendTime === args.timestamp) {
              this.messageList[i].sendState = 2
              clearTimeout(this.messageList[i].timer)
              break
            }
          }
        }
      } else {
        msgStorage.save(args.userId, args.userType, args.newMsg.fromAuthor, args.timestamp, args.newMsg.type, args.newMsg.data.text, isSend, true)
        if (this.participants.length === 0) return
        if (args.newMsg && args.userId === this.participants[0].userId && args.userType === this.participants[0].userType) {
          this.messageList.push({
            type: 'text',
            author: args.newMsg.fromAuthor,
            data: {
              text: args.newMsg.data.text
            },
            hidden: args.newMsg.hidden,
            sendTime: args.timestamp
          })
        }
      }
    },
    convert (timestamp) {
      if (timestamp) {
        const d = new Date(timestamp)
        return d.getFullYear() + '-' +
          this.repairZero(d.getMonth() + 1) + '-' +
          this.repairZero(d.getDate()) + ' ' +
          this.repairZero(d.getHours()) + ':' +
          this.repairZero(d.getMinutes()) + ':' +
          this.repairZero(d.getSeconds())
      }
      return ''
    },
    repairZero (n) {
      n = parseInt(n)
      if (n > 9) {
        return n
      } else {
        return 0 + '' + n
      }
    },
    refreshCurrentContact () {
      console.log('msg', this.participants)
      if (this.participants.length > 0) {
        const userId = this.participants[0].userId
        const userType = this.participants[0].userType
        this.$emit('getUserInfo', userId, userType, o => {
          if (o !== null) {
            console.log('msg', o)
            this.loadHistoryMessage(userId, userType, o.seconds)
          }
        })
      }
    },
    loadHistoryMessage (userId, userType, seconds) {
      // 这里的seconds不可信，可能数据正在补发中，所以只能拉取过去1小时的。
      // const startTime = new Date().getTime() - seconds * 1000 - 10 * 1000
      const startTime = new Date().getTime() - 7200000

      console.log('msg', 'del', userId, userType, startTime, seconds)
      msgStorage.del(userId, userType, startTime)
      msgStorage.get(userId, userType, startTime, (list) => {
        if (list !== null) {
          this.$emit('onFillMessage', userId, userType, list)
          this.loadMessage(this.formatMsg(list))
        }
      })
    }
  },
  destroyed () {
  }
}
</script>

<style scoped>
::v-deep .sc-chat-window {
  width: 370px;
  height: calc(100% - 120px);
  max-height: 590px;
  position: fixed;
  left: 0;
  top: 30px;
  right: 0;
  margin-right: auto;
  margin-left: auto;
  box-sizing: border-box;
  box-shadow: 0 7px 40px 2px rgb(148 149 150 / 10%);
  background: #fff;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  border-radius: 10px;
  font-family: Helvetica Neue, Helvetica, Arial, sans-serif;
  -webkit-animation: fadeIn-data-v-08d4c038;
  animation: fadeIn-data-v-08d4c038;
  -webkit-animation-duration: .3s;
  animation-duration: .3s;
  -webkit-animation-timing-function: ease-in-out;
  animation-timing-function: ease-in-out;
  z-index: 9999;
}

/*::v-deep .sc-message--system {*/
/*  !* padding: 8px 20px; *!*/
/*  !* border-radius: 6px; *!*/
/*  !* font-weight: 300; *!*/
/*  font-size: 12px;*/
/*  line-height: 1.2;*/
/*  white-space: pre-wrap;*/
/*  -webkit-font-smoothing: subpixel-antialiased;*/
/*  !* font-style: italic; *!*/
/*  opacity: .55;*/
/*}*/

.sc-message-system-text {
  font-size: 12px;
  white-space: pre-wrap;
  -webkit-font-smoothing: subpixel-antialiased;
  font-style: normal;
  opacity: 0.7;
}

.chat-msg-loading {
  display: inline-block;
  vertical-align: middle;
  background: url("../assets/ic-msg-send-loading.png") center center;
  background-size: 20px 20px;
  width: 20px;
  height: 20px;
  animation: loading 3s linear infinite;
}

.chat-msg-retry {
  display: inline-block;
  vertical-align: middle;
  background: url("../assets/ic-msg-send-fail.png") center center;
  background-size: 18px 18px;
  width: 18px;
  height: 18px;
  cursor: pointer;
}

@keyframes loading {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>
